import React, { memo } from "react";
import PropTypes from "prop-types";

const Row = memo(({ label, value, children, indented, empty = false }) => {
	return (
		<tr>
			<td className={`label-cell ${indented ? `indent` : ``}`}>{label}</td>
			<td>
				{empty ? `` : value || `-`}
				{children}
			</td>
		</tr>
	);
});
Row.displayName = `Row`;
Row.propTypes = {
	label: PropTypes.string.isRequired,
	value: PropTypes.oneOfType([PropTypes.objectOf(null), PropTypes.string]),
	children: PropTypes.object,
	indented: PropTypes.bool,
	empty: PropTypes.bool
};

export default Row;